var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.29036 9.21387L8.72786 6.33887H5.94661V4.46387C5.94661 3.65137 6.32161 2.90137 7.57161 2.90137H8.85286V0.432617C8.85286 0.432617 7.69661 0.213867 6.60286 0.213867C4.32161 0.213867 2.82161 1.62012 2.82161 4.12012V6.33887H0.259111V9.21387H2.82161V16.2139H5.94661V9.21387H8.29036Z"}));
}

FacebookInline.defaultProps = {"width":"9","height":"17","viewBox":"0 0 9 17"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
